import {
  FETCH_SHARE_TEMPLATE,
  FETCHING_SHARE_TEMPLATE_SUCCEEDED,
  FETCHING_SHARE_TEMPLATE_FAILED,
  UPDATE_SHARE_TEMPLATE,
  UPDATING_SHARE_TEMPLATE_SUCCEEDED,
  UPDATING_SHARE_TEMPLATE_FAILED,
  REPHARSE_LINKEDIN_POST,
  REPHARSING_LINKEDIN_POST_SUCCEEDED,
  REPHARSING_LINKEDIN_POST_FAILED,
  INVALIDATE_SHARE_SETTINGS_UPDATE,
  INVALIDATE_LINKEDIN_POST_TONES
} from "src/redux/actions/actionTypes";
import { ContentType } from "src/types/common";
import { Media } from "src/types/media";
import { IFetchShareTemplateErrorResponse, IFetchShareTemplateRequest, IFetchShareTemplateResponse, IRephraseRequest, IRephraseErrorResponse, IRephraseResponse, IUpdateShareTemplateErrorResponse, IUpdateShareTemplateRequest, IUpdateShareTemplateResponse, IRephraseTones } from "src/types/shareTemplate";

interface IShareTemplate {
  [key: string]: {
    loading: boolean;
    item: {
      mediaDTO : Media,
      message: string
    } | null;
    error: any | null;
    succeeded: boolean;
    updation: {
      loading: boolean;
      error: any | null;
      succeeded: boolean;
    },
    rephrase: {
      loading: boolean;
      error: any | null;
      succeeded: boolean;
    },
    tones:{
      [key: string]:  string
    }
  };
}


const intitalShareTemplate: IShareTemplate = {}


const shareTemplateReducer = (state = intitalShareTemplate, action: any) => {
  switch (action.type) {
    case FETCH_SHARE_TEMPLATE: {
      const { entityId } = action.payload as IFetchShareTemplateRequest;

      return {
        ...state,
        [entityId]: {
          ...state[entityId],
          loading: true,
          item: null,
          error: null,
          succeeded: false,
        }
      };
    }

    case FETCHING_SHARE_TEMPLATE_SUCCEEDED: {
      const { entityId, response } = action.payload as IFetchShareTemplateResponse;

      return {
        ...state,
        [entityId]: {
          ...state[entityId],
          loading: false,
          item: response,
          error: null,
          succeeded: true,
        }
      };
    }

    case FETCHING_SHARE_TEMPLATE_FAILED: {

      const { entityId, error } = action.payload as IFetchShareTemplateErrorResponse;

      return {
        ...state,
        [entityId]: {
          ...state[entityId],
          loading: false,
          error: error,
          succeeded: false
        }
      };
    }

    case UPDATE_SHARE_TEMPLATE: {
      const { entityId } = action.payload as IUpdateShareTemplateRequest;

      return {
        ...state,
        [entityId]: {
          ...state[entityId],
          updation: {
            loading: true,
            error: null,
            succeeded: false
          }
        }
      };
    }

    case UPDATING_SHARE_TEMPLATE_SUCCEEDED: {
      const { entityId, response } = action.payload as IUpdateShareTemplateResponse;

      return {
        ...state,
        [entityId]: {
          ...state[entityId],
          item: response,
          updation: {
            loading: false,
            error: null,
            succeeded: true
          },
        }
      };
    }

    case UPDATING_SHARE_TEMPLATE_FAILED: {
      const { entityId, error } = action.payload as IUpdateShareTemplateErrorResponse;

      return {
        ...state,
        [entityId]: {
          ...state[entityId],
          updation: {
            loading: false,
            error: error,
            succeeded: false
          }
        }
      };
    }

    case REPHARSE_LINKEDIN_POST: {
      const { entityId, rephraseTone } = action.payload as IRephraseRequest;

      return {
        ...state,
        [entityId]: {
          ...state[entityId],
          rephrase: {
            loading: true,
            error: null,
            succeeded: false
          }
        }
      };
    }

    case REPHARSING_LINKEDIN_POST_SUCCEEDED: {
      const { entityId, response, rephraseTone } = action.payload as IRephraseResponse;

      return {
        ...state,
        [entityId]: {
          ...state[entityId],
          rephrase: {
            loading: false,
            error: null,
            succeeded: true
          },
          tones:{
            ...state[entityId].tones,
            [rephraseTone]: response
          }
        }
      };
    }

    case REPHARSING_LINKEDIN_POST_FAILED: {
      const { entityId, error } = action.payload as IRephraseErrorResponse;

      return {
        ...state,
        [entityId]: {
          ...state[entityId],
          rephrase: {
            loading: false,
            error: error,
            succeeded: false
          }
        }
      };
    }

    case INVALIDATE_SHARE_SETTINGS_UPDATE: {
      const { entityId } = action.payload as IUpdateShareTemplateRequest;

      return {
        ...state,
        [entityId]: {
          ...state[entityId],
          updation: {
            loading: false,
            error: null,
            succeeded: false
          }
        }
      };
    }

    case INVALIDATE_LINKEDIN_POST_TONES:{
      const entityId = action.payload;

      return {
        ...state,
        [entityId]: {
          ...state[entityId],
          rephrase: {
            loading: false,
            error: null,
            succeeded: false
          },
          tones:{}
        }
      };
    }

    default:
      return state;
  }
}

export default shareTemplateReducer;